import { render, staticRenderFns } from "./buku_NJOPTK_tarif.vue?vue&type=template&id=2489aee6&"
import script from "./buku_NJOPTK_tarif.vue?vue&type=script&lang=js&"
export * from "./buku_NJOPTK_tarif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports